/**
 * Signup page copy, taken verbatim from the legacy Arabic resources.
 *
 *   Locale/Login.ar.resx, Locale/Signup.ar.resx, Locale/Admin/Users.ar.resx,
 *   Locale/Admin/General.ar.resx, Locale/Activate.ar.resx
 *   RawamDemo.sql (Settings -> Default_ArabicApplicationTitle)
 */
export const strings = {
  title: 'التسجيل', // Login.ar.resx -> Signup
  appTitle: 'روام', // RawamDemo.sql -> Default_ArabicApplicationTitle

  /**
   * Signup.ar.resx -> lblLang. Note this reads "العربية" while the Login page's
   * equivalent reads "English" — an inconsistency in the legacy resources,
   * carried over unchanged.
   */

  nameAr: 'الاسم بالعربية', // Users.ar.resx -> SpanNameAr
  nameEn: 'الاسم بالإنجليزية', // Users.ar.resx -> SpanNameEn
  /* The resx name says LABEL, and a label ends in a colon; here the string is a
     floating field label sitting between four others that carry none. Same
     string, without the punctuation of the control it used to belong to. */
  email: 'البريد الإلكتروني', // Users.ar.resx -> EmailLabelResource1.Text
  username: 'اسم المستخدم', // Login.ar.resx -> UserNameLabelResource1.Text
  password: 'كلمة المرور', // Login.ar.resx -> PasswordLabelResource1.Text
  confirmPassword: 'تأكيد كلمة المرور', // Login.ar.resx -> ConfirmPassword

  alreadyRegistered: 'تمتلك حساب مسبقا؟ تسجيل الدخول', // Signup.ar.resx -> lblAlreadyRegistered
  submitting: 'فضلا انتظر', // Admin/General.ar.resx -> WaitScreenLineA
  close: 'إغلاق', // Admin/Users.ar.resx -> btnClose

  messages: {
    required: 'الحقل مطلوب', // Users.ar.resx -> RequiredFieldValidator(.Text)
    length: 'المدخل لابد ألا يقل عن 3 أحرف و لا يزيد عن 200', // Users.ar.resx -> Regex200.Text
    emailRequired: 'البريد الإلكتروني مطلوب', // Users.ar.resx -> EmailRequiredResource1.ErrorMessage1
    // Users.ar.resx -> CreateUserWizardSingleUserResource1.InvalidEmailErrorMessage1
    emailInvalid: 'من فضلك قم ادخال بريد الكتروني صحيح',
    // Users.ar.resx -> CreateUserWizardSingleUserResource1.ConfirmPasswordCompareErrorMessage
    passwordMismatch: 'تأكيد كلمة المرور لا يتطابق مع كلمة المرور',

    // ---- Server responses from SignupController.Signup ----
    // Users.ar.resx -> CreateUserWizardSingleUserResource1.CompleteSuccessText
    accountCreated: 'تم إنشاء الحساب بشكل صحيح',
    // Signup.ar.resx -> DuplicatedUsernameMessage
    duplicateUsername: 'اسم مستخدم مكرر يرجى تحديد اسم آخر',
    // Signup.ar.resx -> DuplicatedEmailMessage
    duplicateEmail: 'بريد إلكتروني مكرر يرجى تحديد بريد إلكتروني آخر',
    // Signup.ar.resx -> PasswordValidationMessage
    passwordPolicy:
      'يجب أن تكون كلمة المرور بين 6 و 15 حرفًا ، وأن تحتوي على رقم واحد على الأقل ورموز خاصة واحدة.',

    /* Only when the request never reached a handler. A refusal — a taken username,
       an expired invitation, a full licence — is always the server's own wording. */
    systemError: 'حدث خطأ في النظام، فضلا حاول مرة أخرى',
  },

  /** Registration is closed: the invitation expired, signup is off, or the licence is full. */
  closedTitle: 'التسجيل غير متاح',
  backToLogin: 'العودة لتسجيل الدخول', // Login.ar.resx -> BackToLogin

  logoAlt: 'روام',
}

/** Activate/Index copy — where Signup lands once the account is created. */
export const activateStrings = {
  title: 'تفعيل حسابات المستخدمين', // General.ar.resx -> ActivateUser.Description
  logout: 'تسجيل خروج', // TermsOfUse.ar.resx -> BtnLogout.Text

  states: {
    // Activate.ar.resx -> MessageSentMessage (Activate/WaitingUser)
    waitingUser:
      'مرحبا تم ارسال بريد إلكتروني لك يحتوي على رابط تفعيل الحساب الرجاء الضغط عليه لتفعيل حسابك',
    // Activate.ar.resx -> WaitingActivationMessage (Activate/WaitingAdmin)
    waitingAdmin: 'مرحبا حسابك الآن في مرحلة إنتظار الموافقة من مدير النظام',
    /* The three states ForceRedirectionMiddleware sends an account to. Wording is
       Common/Localization/ar-SA.json verbatim, so the screen says exactly what the
       server would have said. */
    expired: 'انتهت فترة صلاحية حسابك', // AccountExpiredMessage
    resigned: 'تم قبول استقالة صاحب الحساب', // ResignedMessage
    suspended: 'تم تعطيل حسابك', // AccountSuspendedMessage
  },

  /* The activation link could not be read — a used or malformed token. The server
     answers its own wording when it CAN read it; this covers the case where the
     call itself failed. */
  confirmFailed: 'تعذّر تفعيل الحساب، فضلا تأكد من الرابط أو تواصل مع مدير النظام',
  goToLogin: 'الذهاب لتسجيل الدخول',
}
